<template>
  <el-row>
    <el-col :span="24">
      <el-card shadow="none">
        <div class="board-main">
          <div class="board-bg-main hidden-xs-only mr-20">
            <p class="board-text">公告设置</p>
          </div>
          <el-form :model="notice"
                   ref="notice"
                   class="board-form">
            <el-form-item label="是否启用:"
                          prop="status">
              <el-switch v-model="notice.status"
                         active-color="#13ce66"
                         inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
            <el-form-item label="公告标题:"
                          prop="title">
              <el-input v-model.trim="notice.title"
                        placeholder="请输入公告标题"></el-input>
            </el-form-item>
            <el-form-item label="公告内容:"
                          prop="content">
              <el-input v-model.trim="notice.content"
                        placeholder="请输入公告内容"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button v-has="'/notice/edit'"
                         type="primary"
                         @click="handleConfirm('notice')">确 定</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
export default {
  data() {
    return {
      notice: {
        id: 1,
        status: 1,
        title: '',
        content: ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取数据
    getList() {
      fetch.getNoticeOne({ id: this.notice.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.notice = data
            this.notice.status = data.status === '1' ? true : false
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(this.notice))
          datas.status = datas.status ? '1' : '0'
          fetch.editNotice({ ...datas }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.getList()
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.board-main {
  display: flex;
  .board-bg-main {
    width: 150px;
    height: 228px;
    line-height: 228px;
    background: url('../../../assets/img/notice.png') no-repeat 30px 80px, #fff;
    background-size: 80px auto;
    border-right: 1px solid #eaeefb;
    .board-text {
      line-height: 60px;
      text-align: center;
      font-weight: 900;
      margin-left: -10px;
      font-size: 16px;
      color: #909399;
    }
  }
  .board-form {
    flex: 1;
  }
}
</style>
